module.exports = __webpack_public_path__ + "img/mifan.eed0de24.png";